import { Navigate, Route, Routes } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "./lib/api";
import { LoginPage } from "./pages/LoginPage";
import { MailShell } from "./components/MailShell";
import { MailboxPage } from "./pages/MailboxPage";

export interface MailSession {
  id: string;
  email: string;
  displayName: string;
  realm: "MAIL";
  readingPane: "OFF" | "RIGHT";
  theme: "SYSTEM" | "LIGHT" | "DARK";
}

function ProtectedMail() {
  const session = useQuery({ queryKey: ["mail", "session"], queryFn: () => api<MailSession>("/auth/mail/me"), retry: false });
  if (session.isPending) return <div className="grid min-h-[100dvh] place-items-center bg-background"><div className="size-7 animate-pulse rounded-md bg-primary" /></div>;
  if (session.isError) return <Navigate to="/login" replace />;
  return <MailShell session={session.data} />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedMail />}>
        <Route index element={<MailboxPage />} />
        <Route path=":mailboxId/:folder" element={<MailboxPage />} />
        <Route path=":mailboxId/:folder/thread/:threadId" element={<MailboxPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
